import Vue from 'vue';
import Vuex from 'vuex';
import { Provider } from './types/response';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    clientId: process.env.VUE_APP_CLIENT_ID,
    serverUrl: process.env.VUE_APP_MWS_URL,
    stripePublicKey: process.env.VUE_APP_STRIPE_KEY,
    publicUrl: [
      '/register',
      '/subscription-plan',
    ],
    preferredProviders: [],
  },
  mutations: {
    SET_PREFERRED_PROVIDER(state, providers: Provider[]) {
      state.preferredProviders = providers as any;
    },
  },
  actions: {

  },
});
